import { render, staticRenderFns } from "./SelectClass.vue?vue&type=template&id=4aadde17&"
import script from "./SelectClass.vue?vue&type=script&lang=ts&"
export * from "./SelectClass.vue?vue&type=script&lang=ts&"
import style0 from "./SelectClass.vue?vue&type=style&index=0&id=4aadde17&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports